import { app } from "./main-app"
import ToastService from "primevue/toastservice"

app.use(ToastService)
